import React from 'react';
import {
  Box,
  Typography,
  Link,
  IconButton,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Link as ScrollLink } from 'react-scroll';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const footerLinks = ['Home', 'About', 'Courses', 'Services', 'Achievements', 'Testimonials'];

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(to right, #0c1e3c, #1a2a4f)',
        color: '#ffffffcc',
        py: 5,
        px: 3,
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        borderTop: '3px solid #ffcb05',
      }}
    >
      {/* 🔗 Navigation Links */}
      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={isMobile ? 1 : 3}
        justifyContent="center"
        alignItems="center"
        sx={{ mb: 3, flexWrap: 'wrap' }}
      >
        {footerLinks.map((section, index) => (
          <ScrollLink
            key={index}
            to={section.toLowerCase()}
            smooth={true}
            duration={600}
            offset={-70}
            style={{
              fontWeight: 500,
              color: '#ffcb05',
              textDecoration: 'none',
              fontSize: '0.95rem',
              cursor: 'pointer',
            }}
          >
            {section}
          </ScrollLink>
        ))}
      </Stack>

      {/* 📍 Company Address */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ fontSize: '0.9rem', lineHeight: 1.6 }}>
          📌 <strong>Registered Address:</strong><br />
          1-59/A, Kondepalli, Nellepalli, Chittoor, Andhra Pradesh – 517167
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.9rem', mt: 1 }}>
          🏢 <strong>Upcoming Branches:</strong> Salem, Chennai, Hyderabad
        </Typography>
      </Box>

      {/* 🌐 Social Media Icons */}
      <Box sx={{ mb: 3 }}>
        <IconButton
          href="https://www.instagram.com/sparkai_edtech?igsh=MWptMnk4dzFwZGs5dg=="
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#ffcb05', mx: 1 }}
        >
          <InstagramIcon fontSize={isMobile ? 'medium' : 'large'} />
        </IconButton>
        <IconButton
          href="https://www.linkedin.com/company/spark-ai-edu-tech/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#ffcb05', mx: 1 }}
        >
          <LinkedInIcon fontSize={isMobile ? 'medium' : 'large'} />
        </IconButton>
      </Box>

      {/* © Copyright */}
      <Typography variant="body2" sx={{ fontSize: '0.85rem', mb: 1 }}>
        © {new Date().getFullYear()} <strong style={{ color: '#ffcb05' }}>Spark AI Edutech Solutions</strong> • All Rights Reserved.
      </Typography>

      {/* 🔝 Back to Top */}
      <Link
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        underline="none"
        sx={{
          display: 'block',
          mt: 1,
          color: '#ffffff99',
          fontSize: '0.85rem',
          cursor: 'pointer',
          '&:hover': { color: '#ffcb05' },
        }}
      >
        🔝 Back to Top
      </Link>
    </Box>
  );
}

export default Footer;
